// Install these packages:
// npm install xlsx jspdf jspdf-autotable

import { utils, write } from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

// Function to export table data to Excel
export const exportToExcel = (tableData, fileName = "รายงานสต๊อกคงคลัง") => {
  try {
    // Format data for Excel
    const excelData = tableData.map(product => ({
      'รหัสสินค้า': product.product_code || "-",
      'ชื่อสินค้า': product.product_name || "-",
      'Serial Number': product.product_serial ? product.product_serial.join(", ") : "-",
      'หมวดหมู่': product.product_category || "-",
      'คลังสินค้า': product.data[0].warehouse_data || "-",
      'จำนวนคงเหลือ': product.data[0].quantity || "0"
    }));

    // Create worksheet
    const worksheet = utils.json_to_sheet(excelData);
    
    // Set column widths
    const wscols = [
      { wch: 15 }, // รหัสสินค้า
      { wch: 40 }, // ชื่อสินค้า
      { wch: 20 }, // Serial Number
      { wch: 15 }, // หมวดหมู่
      { wch: 15 }, // คลังสินค้า
      { wch: 15 }  // จำนวนคงเหลือ
    ];
    worksheet['!cols'] = wscols;

    // Create workbook
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, fileName);

    // Generate Excel file
    const excelBuffer = write(workbook, { bookType: 'xlsx', type: 'array' });
    
    // Create blob and download
    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${fileName}_${moment().format('YYYY-MM-DD')}.xlsx`;
    link.click();
    URL.revokeObjectURL(url);
    
    return true;
  } catch (error) {
    console.error("Error exporting to Excel:", error);
    return false;
  }
};


// Function to export table data to PDF
export const exportToPDF = (tableData, branchInfo, fileName = "รายงานสต๊อกคงคลัง") => {
  try {
    // Format the table data in a simple tabular structure
    const tableRows = tableData.map(product => [
      { text: product.product_code || "-", alignment: "left" },
      { text: product.product_name || "-", alignment: "left" },
      { text: product.product_serial ? product.product_serial.join(", ") : "-", alignment: "left" },
      { text: product.product_category || "-", alignment: "center" },
      { text: product.data[0].warehouse_data || "-", alignment: "left" },
      { text: product.data[0].quantity || "0", alignment: "center" }
    ]);
    
    // PDF document definition
    const docDefinition = {
      content: [
        // Logo and header
        {
          columns: [
            {
              stack: [
                { text: fileName, fontSize: 24, bold: true, margin: [0, 5, 0, 0] },
                { text: `สาขา: ${branchInfo?.branch_name || ''}`, fontSize: 14 },
                { text: `วันที่พิมพ์: ${moment().format('DD/MM/YYYY HH:mm')}`, fontSize: 12 }
              ],
              margin: [10, 0, 0, 0]
            }
          ]
        },
        { text: " ", margin: [0, 10, 0, 0] },
        
        // Main table - simple structure without merging columns
        {
          table: {
            headerRows: 1,
            widths: ['15%', '30%', '15%', '15%', '15%', '10%'],
            body: [
              [
                { text: "รหัสสินค้า", alignment: "center", fillColor: "#0F4C81", color: "#ffffff" },
                { text: "ชื่อสินค้า", alignment: "center", fillColor: "#0F4C81", color: "#ffffff" },
                { text: "Serial Number", alignment: "center", fillColor: "#0F4C81", color: "#ffffff" },
                { text: "หมวดหมู่", alignment: "center", fillColor: "#0F4C81", color: "#ffffff" },
                { text: "คลังสินค้า", alignment: "center", fillColor: "#0F4C81", color: "#ffffff" },
                { text: "จำนวน", alignment: "center", fillColor: "#0F4C81", color: "#ffffff" }
              ],
              ...tableRows
            ]
          }
        }
      ],
      defaultStyle: { 
        font: "THSarabunNew", 
        fontSize: 16, 
        lineHeight: 1 
      },
      pageSize: "A4",
      pageMargins: [15, 15, 15, 15],
      pageOrientation: 'landscape',
    };
    
    // Generate and open PDF
    pdfMake.createPdf(docDefinition).open();
    
    return true;
  } catch (error) {
    console.error("Error exporting to PDF:", error);
    return false;
  }
};
